import { Component } from '@angular/core';

@Component({
  selector: 'under-construction',
  styles: [ require('./under-construction.component.scss') ],
  template: require('./under-construction.component.html')
})
export class UnderConstructionComponent {
  constructor() {

  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/components/under-construction/under-construction.component.ts